import React from 'react';
import { isEqual } from 'lodash';
import request from 'utils/request_ajax';

// If you have a component (e.g. <DoSomethingWithData />) that depends on some
// data from the server, you can wrap it in <DataProvider /> to abstract out the
// details of the AJAX request. <DataProvider /> take a `url` and optional
// `params` and yields its status (a `loading` boolean) and eventually `data`
// (the server response) to its only child, which it expects to be a function.
//
// Example in action:
//
//     <DataProvider url="/get_data.json" params={{ token }}>
//       {({ data, loading }) => (
//         <div>
//           {loading && t('common.loading')}
//           {!loading && <DoSomethingWithData data={data} />}
//         </div>
//       })
//     </DataProvider>
//
class DataProvider extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: null,
    };
    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.url !== this.props.url ||
      !isEqual(prevProps.params, this.props.params)
    ) {
      this.fetchData();
    }
  }

  fetchData() {
    this.setState({ loading: true });
    request
      .get(this.props.url, this.props.params)
      .then(data => this.setState({ data, loading: false }));
  }

  render() {
    return this.props.children({
      data: this.state.data,
      loading: this.state.loading,
    });
  }
}

export default DataProvider;
